// extracted by mini-css-extract-plugin
module.exports = {"loading":"bz","fullscreenWrapper":"bA","centeredSpinner":"bB","rotation":"bC","withoutLayer":"bD"};